export const pt = {
  menuBar: {
    file: {
      newFile: 'Novo padrão',
      savePNG: 'Salvar como PNG',
      saveJPG: 'Salvar como JPG',
      saveProject: 'Salvar projeto',
      openProject: 'Abrir projeto',
      unsavedChangesWarning: 'Você tem alterações não salvas. Tem certeza de que deseja criar um novo padrão?'
    },
    display: {
      showGuides: 'Mostrar guias'
    },
    donate: 'Apoiar este projeto',
    undo: 'Desfazer',
    redo: 'Refazer'
  },
  newProject: {
    title: 'Novo padrão',
    settings: {
      wedges: 'Número de setores',
      rows: 'Número de carreiras',
      circleStep: 'Passo do círculo',
      radialStep: 'Passo das linhas radiais',
      stitchScale: 'Escala dos pontos'
    },
    buttons: {
      create: 'Criar',
      cancel: 'Cancelar'
    }
  },
  stitchTypes: {
    title: 'Tipos de pontos',
    color: 'Cor do ponto',
    'single': 'Ponto baixo',
    'double': 'Ponto alto',
    'treble': 'Ponto alto duplo',
    'chain': 'Corrente',
    'slip': 'Ponto baixíssimo',
    'half-double': 'Meio ponto alto',
    'magic-ring': 'Anel mágico',
    'picot': 'Picô',
    'double-treble': 'Ponto alto triplo',
    'triple-treble': 'Ponto alto quádruplo',
    'front-post-dc': 'Ponto alto relevo frontal',
    'back-post-dc': 'Ponto alto relevo traseiro'
  },
  help: {
    title: 'User Guide',
    close: 'Close',
    basics: {
      title: 'Basic Usage',
      content: 'Doily.app is an editor for creating circular crochet patterns. Select a stitch type and color from the right panel, then click on the canvas to place stitches. You can drag placed stitches to reposition them. Click a stitch to select it, press Delete to remove it, or Escape to deselect.'
    },
    stitches: {
      title: 'Stitches and Placement',
      content: 'The right panel offers over 40 stitch variants organized in five categories: basic stitches (chain, slip, single, half-double, double, treble, double treble, triple treble, picot, puffs, clusters), increases, decreases, misc (magic ring, front/back loop, front/back post DC), and markers (numbered and directional). Many stitches have variant options — click the small dropdown arrow below a stitch to switch between them. Hover over the canvas to see a placement preview, then click to place. Use Ctrl+Z (Cmd+Z on Mac) to undo and Ctrl+Shift+Z to redo.'
    },
    orientation: {
      title: 'Orientation Center',
      content: 'The orientation crosshair determines the direction stitches face — they automatically rotate to point toward it. Ctrl+click (Cmd+click on Mac) anywhere on the canvas to move it. Double-click the orientation center to reset it to the pattern center.'
    },
    symmetry: {
      title: 'Radial Symmetry',
      content: 'Use the Symmetry dropdown in the top toolbar to enable radial symmetry (2 to 36 axes). When active, every stitch you place is automatically duplicated around the center. Ghost previews show where copies will appear. Hold Shift while placing to temporarily skip symmetry for a single stitch. You can delete or drag individual copies independently.'
    },
    guides: {
      title: 'Guide Lines',
      content: 'Guides help with precise stitch placement. Toggle them with the "Show Guides" checkbox in the top toolbar. The grid shows radial lines and concentric circles based on your project settings. When symmetry is active, dashed blue lines show the symmetry axes. Guide visibility also affects exported images.'
    },
    colors: {
      title: 'Working with Colors',
      content: 'Choose a stitch color from the 40-color palette in the right panel. Hover over a swatch to see its hex code. All newly placed stitches use the selected color. To change an existing stitch\'s color, select the Recolor tool (paint bucket icon in the toolbar), then click or drag over stitches to repaint them.'
    },
    saving: {
      title: 'Saving Your Pattern',
      content: 'Your pattern is automatically saved in the browser as you work. Use the file menu to: create a new pattern, save as PNG or JPG (the exported image includes a legend of all stitch types used), export an editable .doilyapp project file you can share or back up, or open a previously saved project.'
    },
    tools: {
      title: 'Eraser and Recolor Tools',
      content: 'The toolbar includes an Eraser (X icon) and a Recolor tool (paint bucket). Click the tool icon to activate it, then click or drag across stitches on the canvas. The Eraser removes stitches, and the Recolor tool changes them to the currently selected color. Click the tool icon again to deactivate it.'
    }
  },
  stitchesPanel: {
    symmetry: 'Simetria',
    symmetryOff: 'Desativada',
    eraser: 'Borracha',
    recolor: 'Mudar cor',
    group_stitch: 'Pontos', group_increase: 'Aumentos', group_decrease: 'Diminuições', group_misc: 'Diversos', group_marker: 'Marcadores',
  },
  copyright: {
    text: '© {year} Criado por Julie N. usando',
    cursor: 'Cursor'
  },
  legend: {
    signature: 'Feito com doily.app.craftodejnice.cz'
  }
};
